module.exports = __webpack_public_path__ + "static/media/office-day.3f45b450.jpg";